import { styled } from '@mui/material';
import React__default from 'react';
import { Helmet } from 'react-helmet';

const PreloadFonts = () => {
    return (React__default.createElement(Helmet, null,
        React__default.createElement("link", { rel: "preconnect", href: "https://fonts.googleapis.com" }),
        React__default.createElement("link", { href: "https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap", rel: "stylesheet" })));
};
const GenericContainer = styled('div')({
    fontFamily: 'Poppins, sans-serif',
});

export { GenericContainer, PreloadFonts };
//# sourceMappingURL=GenericContainer.js.map
